<my-content placeholder="main">
    <div class="paymentTitle">REDIRECTING TO PAYMENT</div>

    <div class="paymentTitle">
        <fa-icon style="font-size: 3em;" [icon]="faSpinner" [spin]="true"></fa-icon>
    </div>
</my-content>
